import * as React from "react";
import type { SVGProps } from "react";
const SvgIconGoodCause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M8 1.1c3.81 0 6.9 3.09 6.9 6.9S11.8 14.9 8 14.9 1.1 11.8 1.1 8 4.2 1.1 8 1.1"
      fill="#F7F3FF"
    />
    <path
      d="M6.76 4.12 5.02 6.94l.33 4.77h5.28q.3 0 .52-.19.23-.2.27-.48l.54-3.58q.03-.17-.02-.34-.04-.17-.16-.3-.1-.14-.27-.2-.15-.09-.33-.08H8.17V4.52q0-.32-.22-.54-.23-.23-.54-.23-.2 0-.37.1-.18.1-.28.27"
      fill="white"
    />
    <path
      d="M8 1.1c3.81 0 6.9 3.09 6.9 6.9S11.8 14.9 8 14.9 1.1 11.8 1.1 8 4.2 1.1 8 1.1"
      stroke="#8B5CF6"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m5.02 6.94 1.74-2.82q.1-.17.28-.27.16-.1.37-.1.32 0 .54.23.21.22.22.54v2.02h3.01q.18 0 .33.07t.27.21.16.3q.05.17.02.34l-.54 3.58q-.04.29-.27.48-.22.2-.52.2H5.35"
      stroke="#8B5CF6"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconGoodCause;
